import posthog from "posthog-js";
import { updateGoogleConsent } from "./google-consent";
import { setGtm } from "./gtm";
import { flushPendingPostHogIdentify, setPostHog } from "./posthog";

export const setOsano = () => {
  if (!window.Osano?.cm) {
    console.error("Osano Consent Manager is not loaded.");
    return;
  }

  window.Osano.cm.addEventListener("osano-cm-consent-saved", (consent) => {
    const analytics = consent.ANALYTICS === "ACCEPT";

    // Push the consent update before injecting the container, so the tags read
    // the visitor's state on their first evaluation rather than the denied
    // default seeded at startup. Ad signals follow MARKETING, not ANALYTICS.
    updateGoogleConsent({
      analytics,
      marketing: consent.MARKETING === "ACCEPT",
    });

    if (analytics) {
      setPostHog();
      posthog.opt_in_capturing();
      flushPendingPostHogIdentify();
      setGtm();
    } else {
      posthog.opt_out_capturing();
    }
  });
};
